import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const propertyMapModuleDefaultVariants = {}
const propertyMapModuleCompoundVariants = []

const propertyMapModuleSlotNames = [
  [
    "container",
    "property-map-module__container"
  ],
  [
    "stack",
    "property-map-module__stack"
  ],
  [
    "controls",
    "property-map-module__controls"
  ],
  [
    "toolbar",
    "property-map-module__toolbar"
  ],
  [
    "skeletonControl",
    "property-map-module__skeletonControl"
  ],
  [
    "skeletonCanvas",
    "property-map-module__skeletonCanvas"
  ],
  [
    "field",
    "property-map-module__field"
  ],
  [
    "viewport",
    "property-map-module__viewport"
  ],
  [
    "canvas",
    "property-map-module__canvas"
  ],
  [
    "status",
    "property-map-module__status"
  ],
  [
    "zoomControls",
    "property-map-module__zoomControls"
  ],
  [
    "mapControls",
    "property-map-module__mapControls"
  ],
  [
    "gestureHint",
    "property-map-module__gestureHint"
  ]
]
const propertyMapModuleSlotFns = /* @__PURE__ */ propertyMapModuleSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, propertyMapModuleDefaultVariants, getSlotCompoundVariant(propertyMapModuleCompoundVariants, slotName))])

const propertyMapModuleFn = memo((props = {}) => {
  return Object.fromEntries(propertyMapModuleSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const propertyMapModuleVariantKeys = []
const getVariantProps = (variants) => ({ ...propertyMapModuleDefaultVariants, ...compact(variants) })

export const propertyMapModule = /* @__PURE__ */ Object.assign(propertyMapModuleFn, {
  __recipe__: false,
  __name__: 'propertyMapModule',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: propertyMapModuleVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, propertyMapModuleVariantKeys)
  },
  getVariantProps
})